// Libs
import * as yup from 'yup';
import { TFunction } from 'i18next';
// Others
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { IContactForm } from '~/utils/interface/contact';

export const schema = (t: TFunction) => {
  return yup.object().shape({
    firstName: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    lastName: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    email: yup
      .string()
      .trim()
      .optional()
      .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
        if (value && !REG_EXP.EMAIL.test(value)) return false;
        return true;
      }),
    phoneNumber: yup
      .string()
      .trim()
      .optional()
      .test('isValidPhone', t('common_validate_invalid_phone_number', { ns: 'common/base' }), (value) => {
        return !value || REG_EXP.PHONE_NUMBER.test(value);
      }),
    address: yup.string().trim().optional(),
    address2: yup.string().trim().optional(),
    city: yup.string().trim().optional(),
    state: yup.string().trim().optional(),
    zipCode: yup.string().trim().optional(),
    country: yup.string().trim().optional(),
    latitude: yup.number().optional(),
    longitude: yup.number().optional(),
    countryCode: yup.string().trim().optional(),
  });
};

export const defaultValuesForm: IContactForm = {
  firstName: EMPTY_STRING,
  lastName: EMPTY_STRING,
  email: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  address: EMPTY_STRING,
  address2: EMPTY_STRING,
  city: EMPTY_STRING,
  state: EMPTY_STRING,
  zipCode: EMPTY_STRING,
  country: EMPTY_STRING,
  countryCode: EMPTY_STRING,
};
